import { Box, CircularProgress } from "@mui/material";
import Grid from "@mui/material/Grid2";

/**
 * Reusable loading indicator component
 *
 * @param {Object} props - Component props
 * @param {Object} props.sx - Optional additional styling
 * @returns {JSX.Element} Centered loading spinner
 */
const LoadingIndicator = ({ sx = {} }) => (
  <Grid width="100%" py={5} sx={sx}>
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <CircularProgress />
    </Box>
  </Grid>
);

export default LoadingIndicator;
